import { Alert, AlertTitle, Snackbar } from "@mui/material";
import { useAlerts } from "../../store/alerts/hooks";
import { Transition } from "../../pages/app/utils/animation";

export const GlimpseAlert = () => {
  const { showGlimpseAlert, closeGlimpseAlert } = useAlerts();

  return (
    <Snackbar
      open={showGlimpseAlert}
      onClose={() => closeGlimpseAlert()}
      autoHideDuration={5000}
      message="This Snackbar will be dismissed in 5 seconds."
      slots={{
        transition: Transition,
      }}
      sx={{
        "&.MuiSnackbar-root": {
          transform: "translate(-50%, -50%)",
          top: "50%",
          left: "50%",
        },
      }}
    >
      <Alert
        onClose={() => closeGlimpseAlert()}
        severity="info"
        variant="outlined"
        sx={{ bgcolor: "background.paper", maxWidth: 500, boxShadow: 3 }}
      >
        <AlertTitle>This case only has one clip.</AlertTitle>
        GLIMPSE requires a matching model. There are no other clips with the
        same sample rate and number of channels available. Please create or
        upload a model.
      </Alert>
    </Snackbar>
  );
};
